import React, { useState, FormEvent, useEffect } from 'react'
import OutlinedInput from '../../components/outlinedInput/OutlinedInput'
import Text from '../../components/text/Text'
import './CreatePromotion.css'
import {
    IOnChangeDataPromotionOnline,
    PromotionMarketPlaceComponent,
} from '../../components/promotions/marketplace/PromotionMarketplaceComponent'
import { useNavigate } from 'react-router-dom'
import routes from '../../router/routes'

export default function CreatePromotion() {
    const navigate = useNavigate()

    const [showInstoreCard, setShowInstoreCard] = useState(false)

    const [valid, setValid] = useState(false)
    const [discount, setDiscount] = useState('')
    const [minAmount, setMinAmount] = useState('')
    const [promoName, setPromoName] = useState('')

    const [online, setOnline] = useState<IOnChangeDataPromotionOnline>()

    const PromotionButtonTypeComponent = ({
        text,
        onPress,
    }: {
        text: string
        onPress: () => void
    }) => {
        return (
            <div className="promotion-button-parent" onClick={onPress}>
                <Text
                    label={text}
                    fontSize={24}
                    color="#565656"
                    fontWeight={600}
                />
            </div>
        )
    }

    useEffect(() => {
        setValid(
            discount !== undefined &&
                /^([0-9])*$/.test(discount) &&
                Number(discount) > 0 &&
                Number(discount) <= 100 &&
                minAmount !== undefined &&
                /^([0-9])*$/.test(minAmount) &&
                Number(minAmount) >= 0
        )
    }, [discount, minAmount])

    const reviewPromotionInfo = () => {
        navigate(`/${routes.createPromotion}/${routes.createPromotionDate}`, {
            state: {
                promoName: promoName,
                discount: discount,
                minAmount: minAmount,
                online: online,
            },
        })
    }

    const handleminAmountChange = (event: FormEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value
        setMinAmount(value)
    }
    const handlePromoNameChange = (event: FormEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value

        if (value.length <= 42) {
            setPromoName(value)
        }
    }
    const handleDiscountChange = (event: FormEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value
        setDiscount(value)
    }

    const onChangePromotionOnline = (data: IOnChangeDataPromotionOnline) => {
        setValid(data.valid)
        setOnline(data)
    }

    return (
        <div className="background-create-promotion">
            <Text
                variant="promotion-page-title"
                label="Crear promoción"
                fontSize={27}
                fontWeight={400}
                color={'#184287'}
                marginBottom={70}
            />
            <div className="card-promotion-container">
                <div className="flex-direction-promotion">
                    <div>
                        <Text
                            label="1"
                            fontSize={16}
                            fontWeight={600}
                            color="#184287"
                            textAlign="center"
                        />
                        <Text
                            label="Información de promoción"
                            fontSize={16}
                            fontWeight={600}
                            color="#184287"
                        />
                    </div>
                    <div className="line-promotion" />
                    <div>
                        <Text
                            label="2"
                            fontSize={16}
                            fontWeight={600}
                            color="#BBBBBB"
                            textAlign="center"
                        />
                        <Text
                            label="Asignación de vigencia"
                            fontSize={16}
                            fontWeight={600}
                            color="#BBBBBB"
                        />
                    </div>
                </div>

                <div className="outlined-input-container">
                    <OutlinedInput
                        floatingLabel="Nombre de la promoción"
                        placeholder="Ejemplo: Promoción 2x1"
                        charCounter={true}
                        fieldWrapperStyle={{
                            borderColor: '#BBBBBB',
                            height: 38,
                        }}
                        value={promoName}
                        onChange={handlePromoNameChange}
                        maxLength={42}
                    />
                    <Text
                        label="Selecciona el tipo de compra"
                        fontSize={13}
                        fontWeight={600}
                        color="#565656"
                        marginTop={30}
                        marginBottom={10}
                    />
                    {showInstoreCard ? (
                        <div className="inStoreCard">
                            <div>
                                <Text
                                    label="🍽️  Compra presencial"
                                    fontSize={24}
                                    fontWeight={600}
                                    textAlign="center"
                                />
                            </div>
                            <div className="flex-Direction-create-promotion">
                                <Text
                                    label="Porcentaje de descuento (%)"
                                    fontSize={16}
                                    fontWeight={600}
                                    color="#565656"
                                />
                                <div>
                                    <OutlinedInput
                                        placeholder="10%"
                                        charCounter={true}
                                        fieldWrapperStyle={{
                                            borderColor: '#BBBBBB',
                                            height: 38,
                                            width: 196,
                                        }}
                                        inputStyle={{
                                            textAlign: 'end',
                                            marginRight: 10,
                                            fontFamily: 'Nunito',
                                        }}
                                        value={discount}
                                        onChange={handleDiscountChange}
                                    />
                                </div>
                            </div>
                            <div className="flex-Direction-create-promotion">
                                <Text
                                    label={
                                        'Monto mínimo de comprar para\nefectuar descuento'
                                    }
                                    fontSize={16}
                                    fontWeight={600}
                                    color="#565656"
                                    lineHeight={1}
                                />
                                <div>
                                    <OutlinedInput
                                        placeholder="$10.000"
                                        charCounter={true}
                                        fieldWrapperStyle={{
                                            borderColor: '#BBBBBB',
                                            height: 38,
                                            width: 196,
                                            fontFamily: 'Nunito',
                                        }}
                                        inputStyle={{
                                            textAlign: 'end',
                                            marginRight: 10,
                                        }}
                                        value={minAmount}
                                        onChange={handleminAmountChange}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <PromotionButtonTypeComponent
                            text="🍽️  Compra presencial"
                            onPress={() => {
                                setShowInstoreCard(true)
                            }}
                        />
                    )}
                    <div style={{ marginTop: 20 }} />
                    <PromotionMarketPlaceComponent
                        onChange={onChangePromotionOnline}
                    />
                    <div
                        className={
                            promoName.length > 0 && valid
                                ? 'next-button-container'
                                : 'next-button-container-disabled'
                        }
                        onClick={
                            promoName.length > 0 && valid
                                ? reviewPromotionInfo
                                : undefined
                        }
                    >
                        <Text
                            label="Siguiente"
                            fontSize={16}
                            fontWeight={600}
                            color="white"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
